import React, { ReactElement } from 'react';
import { PreconnectProps } from '../types';

export const Preconnect = ({ config }: PreconnectProps): (ReactElement | null)[] => {
  const { brandNameLower } = config;
  return [`images-${brandNameLower}.b2w.io`, `statics-${brandNameLower}.b2w.io`].map(url => (
    <link key={url} rel="preconnect" href={`https://${url}`} crossOrigin="true" />
  ));
};
